<app-header></app-header>

@if(isHomePage) {
<app-navbar></app-navbar>
}

<div class="layout-container">
    <router-outlet></router-outlet>
</div>

@if(!isAuthPage) {
<app-footer></app-footer>
}